<script>
	import Helper from '../../Models/Helper';
	import Product from '../../States/Product';

	let body = {};

	function propertyActive(property) {
		let active = false;
		for (let option of property.options)
			if (option.active) {
				active = true;
				break;
			}

		return active;
	}

	function propertyOption(property, option) {
		property.chosen = option.counter;

		const item = $Product.api;
		for (let part of item.parts)
			for (let item_property of part.properties)
				if (item_property == property)
					for (let item_option of item_property.options) {
						const active = item_option == option;
						item_option.active = active;
					}

		const correction = () => {
			for (let part of item.parts)
				for (let item_property of part.properties) {
					let activated = false;
					let chosen = item_property.chosen;
					scan:
						for (let item_option of item_property.options)
							if (item_option.active) {
								activated = true;
								if (!optionMatch(item_option)) {
									item_option.active = false;
									part.seen = false;
									let total = 0;
									for (let child_option of item_property.options)
										if (optionMatch(child_option)) total++;

									if (!Helper.undefined(chosen))
										if (chosen >= total)
											chosen = undefined;

									let counter = -1;
									for (let child_option of item_property.options) {
										if (optionMatch(child_option)) {
											counter++;
											if (Helper.undefined(chosen) || (counter === chosen)) {
												item_property.chosen = counter;
												child_option.active = true;
												correction();
												break scan;
											}
										}
									}
								}
							}

				if (!activated)
					for (let item_option of item_property.options)
						if (optionMatch(item_option)) {
							item_property.chosen = 0;
							item_option.active = true;
							activated = true;
							break;
						}
			}
		};

		correction();
		$Product.api = item;
		Product.update();
	}

	function optionMatch(option) {
		let active = true;

		const matches = (option, property, code) => {
			let active = false;
			for (let property_option of property.options)
				if (option.match[code].includes(property_option.code))
					if (property_option.active) {
						active = true;
						break;
					}

			return active;
		};

		if (Helper.is(option.match))
			search:
				for (let code in option.match)
					for (let part of $Product.api.parts)
						for (let property of part.properties)
							if (property.code == code)
								if (!matches(option, property, code)) {
									active = false;
									break search;
								}

		return active;
	}

	Product.subscribe(product => {
		if (product.options_top) {
			body.scrollTop = 0;
			product.options_top = false;
		}
	});
</script>

<style>
	div.phd-panel {
		margin-bottom: 1em;
	}

	div.phd-panel + div.phd-panel {
		border-top: 1px solid var(--phd-quaternary);
		margin-top: 2em;
		padding-top: 2em;
	}

	div.phd-panel div.phd-title {
		font-size: 1.5em;
		font-weight: 600;
		line-height: 1.5em;
		margin-bottom: .2em;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	div.phd-panel > p {
		font-size: 1.25em;
		margin: 0 0 1.6em 0;
	}

	div.phd-selection {
		margin-top: .9em;
	}

	div.phd-selection > p {
		font-size: 1.3em;
		color: var(--phd-tertiary);
		margin: 0;
	}

	div.phd-selection-header {
		display: flex;
	}

	div.phd-selection-title {
		font-size: 1.4em;
		font-weight: 600;
		line-height: 1em;
		margin-bottom: .4em;
		color: var(--phd-secondary);
		width: 75%;
	}

	div.phd-selection-price {
		text-align: right;
		line-height: 1em;
		padding-right: 2em;
		color: var(--phd-quaternary);
		width: 25%;
	}
</style>

{#if Helper.is($Product.properties)}
	<div class="phd-layout">
		<div class="phd-header phd-duo">
			<div>
				<span>Deurmodel</span> {$Product.api.name}
				<div>Incl. meten en monteren</div>
			</div>
			<div>€ {$Product.price}</div>
		</div>
		<div class="phd-body" bind:this="{body}">
			{#each $Product.properties as property}
				{#if propertyActive(property)}
					<div class="phd-property phd-panel" data-counter="{property.counter = 0}">
						<div class="phd-title">{property.name}</div>
						<p>{property.description}</p>
						<div class="phd-options">
							{#each property.options as option}
								{#if optionMatch(option)}
									<div class="phd-option" class:phd-active="{option.active}" data-counter="{option.counter = property.counter++}" on:click="{() => propertyOption(property, option)}">
										<img src="{option.images.gallery.small}" alt="{option.name}"/>
									</div>
								{/if}
							{/each}
						</div>
						{#each property.options as option}
							{#if option.active}
								<div class="phd-selection">
									<div class="phd-selection-header">
										<div class="phd-selection-title">{option.name}</div>
										{#if option.price}
											<div class="phd-selection-price">+ € {option.price}</div>
										{/if}
									</div>
									<p>{option.description}</p>
								</div>
							{/if}
						{/each}
					</div>
				{/if}
			{/each}
		</div>
		<div class="phd-footer phd-duo">
			<div>
				<div class="phd-button phd-secondary" on:click="{() => $Product.options = false}">
					<svg viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M136.97 380.485l7.071-7.07c4.686-4.686 4.686-12.284 0-16.971L60.113 273H436c6.627 0 12-5.373 12-12v-10c0-6.627-5.373-12-12-12H60.113l83.928-83.444c4.686-4.686 4.686-12.284 0-16.971l-7.071-7.07c-4.686-4.686-12.284-4.686-16.97 0l-116.485 116c-4.686 4.686-4.686 12.284 0 16.971l116.485 116c4.686 4.686 12.284 4.686 16.97-.001z"></path></svg>
				</div>
			</div>
			<div>
				<div class="phd-button" on:click="{() => $Product.options = false}">
					<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M435.848 83.466L172.804 346.51l-96.652-96.652c-4.686-4.686-12.284-4.686-16.971 0l-28.284 28.284c-4.686 4.686-4.686 12.284 0 16.971l133.421 133.421c4.686 4.686 12.284 4.686 16.971 0l299.813-299.813c4.686-4.686 4.686-12.284 0-16.971l-28.284-28.284c-4.686-4.686-12.284-4.686-16.97 0z"></path></svg>
				</div>
			</div>
		</div>
	</div>
{/if}